import { Component, OnInit } from '@angular/core';
import { calculateFiscalYear, formatYearRanges } from 'src/app/shared/commen-function-file';
import { ColDef, ExcelExportParams, GridReadyEvent } from 'ag-grid-community';
import { MatDialog } from '@angular/material/dialog';
import { SharedService } from 'src/app/service/shared/shared.service';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { Config } from 'src/app/app-constant';
import { DatePipe } from '@angular/common';
import { DwmGenericServiceService } from '../../_DWM-Generic-Services/generic-service.service';
import { GenericService } from 'src/app/services/genericService/generic.service';
import { GetCompanyAndUsersData } from 'src/app/services/get-company-and-users-data/get-company-and-users-data.service';
import { formatText } from 'src/app/shared/commen-function-file';
import { ToastrService } from 'ngx-toastr';
import { MobileResponsiveService } from 'src/app/services/mobile-view/mobile-responsive.service';

@Component({
  selector: 'app-dwm-report',
  templateUrl: './dwm-report.component.html',
  styleUrls: ['./dwm-report.component.scss']
})
export class DwmReportComponent implements OnInit {
  reportsData: any[] = [];
  searchTaskString: string = '';
  listOfYears: any = [];
  loggedInUserCompanyID: any;
  loggedInCompanyFiscalyear: any;
  selectedYearForDWM: any = null;
  loggedInUserId: any | null;
  isRNDEmployee = false;
  isL4AndAboveEmployee = false;
  loggedInUserEmpCode: any | null;
  productList: any[] = [];
  productMap: any = {};
  loggedInUserRole: any;
  categoryMap: { [key: number]: string } = {};
  selectedMonth: any;
  gradesList: any[] = [];
  isCurrentYearSelected: boolean = false;
  isRndAdminUser = false;
  loggedInUserName: any;
  rndAdminEmployees: any[] = [];

  // ---------------- Pagination for Non-R&D table ----------------

  currentPageNumber = 1;
  selectedSizeOfTask = 25;
  totalTaskCount = 0;
  totalTaskPages = 0;
  showingCount = 0;
  showingOfCount = 0;
  pagedGroupedReportData: any[] = [];
  allowedRNDEmployeeIds: number[] = [];
  isRNDAuthorizedUser = false;

  formatedataVariable = formatText;
  loggedInCompanyReviewCycle: any | null;
  selectedFilters: any = {
    selectedDepartment: null,
    selectedEmpId: null,
    selectedYear: null,
    selectedMonth: null
  };
  pmsYears: any = [];
  fromYear: any;
  selectedYear: any;
  toYear: any;
  isTeamView: boolean = false; // default = SELF
  loggedInUserRoleIsEmployee: any;
  loggedInUserRoles: any;
  isSelectedEmployeeRNDEmployee: boolean | null = null;
  // --------------- Months List -----------------

  filteredMonthsList: string[] = [];
  selectedMonthForDWM: string = '';
  mtdUserId: any = null;
  userIsAdminTypes: any = null;
  adminAccessData: any = null;

  monthsList: string[] = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

  constructor(
    public sharedService: SharedService,
    private encryptionService: EncryptionService,
    private httpService: HttpService,
    private config: Config,
    public dialog: MatDialog,
    private toastr: ToastrService,
    public genericService: GenericService,
    public dwmGenericServiceService: DwmGenericServiceService,
    private datePipe: DatePipe,
    private getCompanyAndUserData: GetCompanyAndUsersData,
    public mobileResponsiveService: MobileResponsiveService
  ) {}

  ngOnInit() {
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));

    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserEmpCode = sessionStorage.getItem('empCode');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    this.loggedInUserName = sessionStorage.getItem('loggedInUserName');

    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.loggedInUserRoles = JSON.parse(sessionStorage.getItem('loggedInUserRoles') || '[]');
    this.loggedInCompanyReviewCycle = sessionStorage.getItem('loggedInCompanyReviewCycle') || null;
    if (this.loggedInUserRoles.length == 1) {
      for (let i = 0; i < this.loggedInUserRoles?.length; i++) {
        if (this.loggedInUserRoles[i].displayName == 'Employee') {
          this.loggedInUserRoleIsEmployee = true;
        }
      }
    }

    // if (this.dwmGenericServiceService?.showMtdView?.value?.userId) {
    //   this.isTeamView = true;
    //   this.onEmployeeChange(this.dwmGenericServiceService?.showMtdView?.value?.userId);
    // }

    this.userIsAdminTypes = this.dwmGenericServiceService.checkIsLoggedInUserIsAdmin();
    if (this.dwmGenericServiceService?.getAllAccessAdmins) {
      this.dwmGenericServiceService.getAllAccessAdmins.subscribe({
        next: (data: any) => {
          if (data?.status) {
            this.adminAccessData = data?.data?.access[0];
            this.executeDataFunction();
          }
        }
      });
    } else {
      this.executeDataFunction();
    }

    // const currentMonthIndex = new Date().getMonth();
    // this.selectedMonthForDWM = this.monthsList[currentMonthIndex];
    // this.checkIfPreviousMonthSelected();
  }

  executeDataFunction() {
    this.getpmsyearlist();
    if (this.dwmGenericServiceService?.showMtdView?.value?.userId) {
      this.isTeamView = true;
      this.onEmployeeChange(this.dwmGenericServiceService?.showMtdView?.value?.userId);
    }
  }

  // --------------- Get PMS Year List -----------------

  getpmsyearlist() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.pmsYears = formatYearRanges(data?.data?.yearRanges);

      const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);
      const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;

      this.setSelectedYear(yearValue);
    });
  }

  // --------------- Set Selected Year -----------------

  setSelectedYear(yearValue: string): void {
    const selectedYearObj = this.pmsYears.find((ele: any) => ele.year === yearValue);
    if (selectedYearObj) {
      this.selectedYearForDWM = selectedYearObj?.year;

      let test = selectedYearObj?.year?.split('-');
      this.fromYear = test[0];
      this.toYear = test[1];
      this.getYearSetupForDWM(this.selectedYearForDWM);
      this.getDwmSetupData();
      this.getActiveExitEmployee();
      // this.getTeamOfManager();
      this.getEmployeeList();
      this.loadAllowedRNDEmployees();
      this.getDepartments();
      this.getReportDataForRNDEmp();
      this.getReportDataForNonRNDEmp();
      this.complianceScore();
      this.getWeeklyOff();

      // this.defaultCallFunctionsList();
      [this.fromYear, this.toYear] = selectedYearObj?.year?.split('-');
    }
  }

  // --------------- Get Year Setup For DWM -----------------

  getYearSetupForDWM(year: any) {
    this.selectedYearForDWM = year;
    this.selectedYear = year;
    const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);

    const currentFiscalYear = `${fiscalStartYear}-${fiscalEndYear}`;

    this.isCurrentYearSelected = year === currentFiscalYear;
    this.filterMonthsByFiscalYear(year);
  }

  filterMonthsByFiscalYear(selectedYear: string) {
    const fiscal = this.loggedInCompanyFiscalyear;
    const [startMon, endMon] = fiscal?.split('_');

    const monthIndex = (mon: string) => new Date(`${mon} 1, 2000`).getMonth();

    const startIdx = monthIndex(startMon);
    const endIdx = monthIndex(endMon);

    this.filteredMonthsList = startIdx <= endIdx ? this.monthsList.slice(startIdx, endIdx + 1) : [...this.monthsList.slice(startIdx), ...this.monthsList.slice(0, endIdx + 1)];

    const currentMonth = new Date().toLocaleString('default', {
      month: 'long'
    });

    this.selectedMonthForDWM = this.isCurrentYearSelected && this.filteredMonthsList.includes(currentMonth) ? currentMonth : '';
    if (!this.selectedMonthForDWM) this.resetFilters('c3');
  }

  // ------------------------------- Get Employee Under the Manager --------------------------
  dailyTeamTaskFromDate = new Date();
  getIndirectEmployees: any = [];

  // getTeamOfManager() {
  //   const request = {
  //     companyId: this.loggedInUserCompanyID,
  //     date: null,
  //     from: this.datePipe.transform(this.dailyTeamTaskFromDate, 'yyyy-MM-dd'),
  //     fromYear: null,
  //     to: this.datePipe.transform(this.dailyTeamTaskFromDate, 'yyyy-MM-dd'),
  //     toYear: null,
  //     userId: this.loggedInUserId,
  //     userType: null,
  //     yearRange: null
  //   };

  //   this.httpService.callPostService(this.config.getTeamOfManagerForDWm, request).subscribe((data: any) => {
  //     this.getIndirectEmployees = [];
  //     data?.data?.forEach((ele: any) => {
  //       let obj = {
  //         name: ele?.firstName + ' ' + ele?.lastName,
  //         id: ele?.id
  //       };
  //       this.getIndirectEmployees.push(obj);
  //     });
  //     this.getIndirectEmployees = this.getIndirectEmployees?.sort((a: any, b: any) => a.name.localeCompare(b.name));

  //   });
  // }

  getActiveExitEmployee() {
    this.httpService.callGetService(`${this.config.getExitedEmployeeUnderManager}?companyId=${this.loggedInUserCompanyID}&managerCode=${this.loggedInUserEmpCode}`).subscribe((res: any) => {
      this.getIndirectEmployees = [];

      if (res?.status && Array.isArray(res?.data)) {
        res.data.forEach((ele: any) => {
          this.getIndirectEmployees.push({
            id: ele.id, // keep as-is (string is fine for ng-select)
            name: `${ele.firstName} ${ele.lastName}`.trim()
          });
        });

        // Sort alphabetically (same UX as before)
        this.getIndirectEmployees = this.getIndirectEmployees.sort((a: any, b: any) => a.name.localeCompare(b.name));
      }
    });
  }

  // ----------------------------- Filter Employees R&D and L4_Above ----------------------
  allEmployees: any[] = [];
  getEmployeeList() {
    this.getCompanyAndUserData.getAllEmployeeByCompanyID().subscribe((res: any) => {
      const empList = res?.data || [];
      this.allEmployees = empList;
      empList.forEach((emp: any) => {
        this.employeeDepartmentMap[emp.id] = emp.department;
      });
      const loggedInEmpId = this.loggedInUserId;
      const loggedInEmployee = empList.find((emp: any) => emp.id === loggedInEmpId);
      /* ---------------- R&D Role ---------------- */
      this.isRNDEmployee = loggedInEmployee?.department === 'R&D';
      /* ---------------- L4 & Above Role ---------------- */
      this.isL4AndAboveEmployee = this.checkL4AndAbove(loggedInEmployee?.grade);
      this.loadAllowedRNDEmployees();
    });
  }

  // ----------------------- Check L4 and Above Employees ---------------------
  checkL4AndAbove(grade: string | null): boolean {
    if (!grade) return false;
    const level = Number(grade.replace('L', ''));
    return level >= 4;
  }

  getDwmSetupData() {
    this.httpService.callGetService(`${this.config.getDwmSetup}?companyId=${this.loggedInUserCompanyID}`).subscribe((res: any) => {
      const setup = res?.data?.[0];
      if (setup?.rndAdmin && this.loggedInUserName) {
        this.isRndAdminUser = setup.rndAdmin.trim().toLowerCase() === this.loggedInUserName.trim().toLowerCase();
        console.log('RND user Admin...', this.isRndAdminUser);
      }
    });
  }

  // Timesheet report
  loadAllowedRNDEmployees() {
    this.httpService.callGetService(`${this.config.getDwmReportConfig}?companyId=${this.loggedInUserCompanyID}`).subscribe((res: any) => {
      const allowedIds = new Set<number>();
      res?.data?.forEach((cfg: any) => {
        cfg.userIds?.forEach((id: number) => allowedIds.add(id));
      });
      this.allowedRNDEmployeeIds = Array.from(allowedIds);
      this.isRNDAuthorizedUser = this.allowedRNDEmployeeIds.includes(Number(this.loggedInUserId));
      console.log('Authorized users...', this.isRNDAuthorizedUser);
      this.rndAdminEmployees = this.allEmployees
        .filter(emp => this.allowedRNDEmployeeIds.includes(Number(emp.id)))
        .map(emp => ({
          id: Number(emp.id),
          name: `${emp.firstName} ${emp.lastName}`
        }))
        .sort((a, b) => a.name.localeCompare(b.name));
      // console.log('1111....', this.rndAdminEmployees);
    });
  }

  employeeDepartmentMap: { [key: number]: string } = {};

  onEmployeeChange(selectedEmpId: number): void {
    this.selectedFilters.selectedEmpId = selectedEmpId;
    this.dwmGenericServiceService.showMtdView.next(null);
    //  Get department from map (NOT dropdown object)
    const department = this.employeeDepartmentMap[selectedEmpId];
    this.isSelectedEmployeeRNDEmployee = department === 'R&D';
    this.getWeeklyOff();
    this.reloadReportsForSelectedEmployee();
    this.complianceScore();
  }

  reloadReportsForSelectedEmployee(): void {
    // Month not selected → do nothing
    if (!this.selectedMonthForDWM) {
      this.reportsData = [];
      this.groupedReportData = [];
      return;
    }
    // R&D report
    if (this.isSelectedEmployeeRNDEmployee) this.getReportDataForRNDEmp();
    // Non-R&D report
    this.getReportDataForNonRNDEmp();
    // this.complianceScore();
  }

  onAdminEmployeeChange(selectedEmpId: number): void {
    this.dwmGenericServiceService.showMtdView.next(null);
    this.selectedFilters.selectedEmpId = selectedEmpId;
    //  Get department from map
    const department = this.employeeDepartmentMap[selectedEmpId];
    this.isSelectedEmployeeRNDEmployee = department === 'R&D';
    this.getWeeklyOff();
    // Load correct report data
    if (this.isSelectedEmployeeRNDEmployee) {
      this.getReportDataForRNDEmp();
      this.complianceScore();
    }
    this.getReportDataForNonRNDEmp();
    this.complianceScore();
  }

  get isSelfView(): boolean {
    return !this.isTeamView;
  }

  get isAdminUser(): boolean {
    return this.loggedInUserRole === 'Super Admin' || this.loggedInUserRole === 'HR Admin' || this.userIsAdminTypes?.userIsAdmin;
  }
  // show report UserRoleWise
  // get shouldShowRndReport(): boolean {
  //   // Admin / HR Admin selecting an employee
  //   if (this.isAdminUser && this.selectedFilters.selectedEmpId) {
  //     return this.isSelectedEmployeeRNDEmployee === true;
  //   }

  //   // Self view R&D employee
  //   if (this.isSelfView && this.isRNDEmployee && !this.isAdminUser) {
  //     return true;
  //   }

  //   // Manager / HOD team view
  //   if (this.isTeamView && (this.loggedInUserRole === 'Manager' || this.loggedInUserRole === 'HOD')) {
  //     return this.isSelectedEmployeeRNDEmployee === true;
  //   }

  //   // R&D Admin
  //   return this.isRndAdminUser === true;
  // }

  // show report UserRoleWise
  get shouldShowRndReport(): boolean {
    const isAuthorized = this.isRNDAuthorizedUser === true || this.isSelectedEmployeeRNDEmployee === true;

    // Admin / HR Admin selecting an employee
    if (this.isAdminUser && this.selectedFilters.selectedEmpId) {
      return this.isSelectedEmployeeRNDEmployee === true && isAuthorized;
    }

    // Self view R&D employee
    if (this.isSelfView && this.isRNDEmployee && !this.isAdminUser) {
      return isAuthorized;
    }

    // Manager / HOD team view
    if (this.isTeamView && (this.loggedInUserRole === 'Manager' || this.loggedInUserRole === 'HOD')) {
      return this.isSelectedEmployeeRNDEmployee === true && isAuthorized;
    }

    // R&D Admin
    return this.isRndAdminUser === true && isAuthorized;
  }

  onTeamToggleChange(isTeam: boolean) {
    this.isTeamView = isTeam;

    if (!isTeam) {
      // SELF view
      this.selectedFilters.selectedEmpId = null;
      this.isSelectedEmployeeRNDEmployee = null;

      // load self data
      if (this.isRNDEmployee) {
        this.getReportDataForRNDEmp();
         this.getReportDataForNonRNDEmp();
        this.complianceScore();
      } else {
        this.getReportDataForNonRNDEmp();
        
        this.complianceScore();
      }
    } else {
      // TEAM view (no employee selected yet)
      this.reportsData = [];
      this.groupedReportData = [];
    }
  }

  filterReportsData(): void {
    let data = [...this.reportsData];
    const isManagerOrHod = this.loggedInUserRole === 'Manager' || this.loggedInUserRole === 'HOD';
    if (isManagerOrHod && !this.selectedFilters.selectedEmpId) {
      this.reportsData = [];
      return;
    }

    if (this.selectedFilters.selectedEmpId) {
      data = data.filter(item => Number(item.userId) === Number(this.selectedFilters.selectedEmpId));
    }

    this.reportsData = data;
  }

  // --------------------------------AG GRID CODE---------------------------------------------------------

  columnDefs: ColDef[] = [
    { headerName: 'Product No', field: 'productNo' },
    { headerName: 'Product Name', field: 'productName' },
    { headerName: 'Plant', field: 'plantLocation' },
    { headerName: 'Business Unit', field: 'businessUnit' },
    { headerName: 'Product Customer', field: 'productCustomer' },
    { headerName: 'Duration', field: 'workedHours' }
  ];

  gridApi: any;
  paginationPageSizeSelector = [5, 10, 20, 50, 100, 200, 500, 1000];
  pagination = true;
  paginationPageSize = 10;
  detailRowAutoHeight = true;

  defaultColDef: ColDef = {
    minWidth: 100,
    filter: true,
    resizable: true,
    sortable: true,
    floatingFilter: false
  };

  gridOptions: any = {
    context: { componentParent: this },
    rowSelection: 'single',
    localeText: {
      noRowsToShow: 'No Data Found'
    }
  };

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
  }

  formatStatus(value: any): string {
    if (!value || typeof value !== 'string') {
      return 'N/A';
    }

    // Camel Case → Title Case
    return value
      ?.toLowerCase()
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  //  Global search function
  onFilterTextBoxChanged(value: string = '') {
    if (!this.gridApi) return;
    this.gridApi.setGridOption('quickFilterText', value ?? '');
  }

  onBtExport() {
    const params: ExcelExportParams = {
      fileName: 'Expense_Report_' + new Date().toISOString().slice(0, 10) + '.xlsx',
      sheetName: 'ExpenseData',
      exportAsExcelTable: {
        showRowStripes: true,
        name: 'ExpenseTable'
      },
      processCellCallback: cell => {
        const header = cell.column.getColDef().headerName;
        const value = cell.value;

        // 1. Date Formatting (for specific headers)
        const dateColumns = ['date', 'dateOfExpense']; // <- field names ya headerName use karo

        if (dateColumns.includes(cell.column.getColId()) && cell.value) {
          const date = new Date(cell.value);
          if (!isNaN(date.getTime())) {
            return ('0' + date.getDate()).slice(-2) + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + date.getFullYear();
          }
        }

        // 2. Status Formatting (make it human readable)
        if (header === 'Status' && value) {
          return value
            .toString()
            .toLowerCase()
            .replace(/_/g, ' ')
            .replace(/\b\w/g, (char: any) => char.toUpperCase());
        }

        return value;
      }
    };

    this.gridApi.exportDataAsExcel(params);
  }

  openFile(fileUrl: string) {
    window.open(fileUrl, '_blank');
  }

  downloadRenderer = (params: any) => {
    if (!params.value) return '';
    const img = document.createElement('img');
    img.src = 'assets/icon/yellowdownload.png';
    img.alt = 'download';
    img.style.width = '18px';
    img.style.height = '18px';
    img.style.cursor = 'pointer';
    img.title = params.value;
    img.addEventListener('click', e => {
      e.stopPropagation();
    });
    return img;
  };

  selectedRow: any;
  isDetailsOpen = false;
  onRowClicked(event: any) {
    this.selectedRow = event.data;
    this.isDetailsOpen = true;
  }
  closeDetails() {
    this.isDetailsOpen = false;
  }

  isClicked = false;

  resetGrid() {
    this.isClicked = true;
    if (this.gridApi) {
      this.gridApi.setFilterModel(null);
      this.gridApi.deselectAll();
      this.searchTaskString = '';
      this.gridApi.setGridOption('quickFilterText', ''); // Clears quick filter text
      this.paginationPageSize = 10;
      this.gridApi.setGridOption('paginationPageSize', this.paginationPageSize);
      this.gridApi.paginationGoToFirstPage();
      this.gridApi.refreshCells();
      this.gridApi.resetColumnState();
    }
  }

  //  --------------------------------------- Get report data for R&D Users --------------------------------------
  getEffectiveUserId(): number {
    return this.selectedFilters.selectedEmpId ? Number(this.selectedFilters.selectedEmpId) : Number(this.loggedInUserId);
  }

  getReportDataForRNDEmp() {
    const isManagerOrHod = this.loggedInUserRole === 'Manager' || this.loggedInUserRole === 'HOD';
    if (this.isTeamView && isManagerOrHod && !this.selectedFilters.selectedEmpId) {
      this.reportsData = [];
      return;
    }

    const payload = {
      companyId: this.loggedInUserCompanyID,
      userId: this.getEffectiveUserId(),
      month: this.monthsList.indexOf(this.selectedMonthForDWM) + 1,
      year: this.getDwmYear()
    };

    this.httpService.callPostService(this.config.dwmReportForRnDUsers, payload).subscribe((res: any) => {
      this.reportsData = res?.data || [];
    });
  }

  get showSelectEmployeeMessage(): boolean {
    const isManagerOrHod = this.loggedInUserRole === 'Manager' || this.loggedInUserRole === 'HOD';
    return isManagerOrHod && !this.selectedFilters.selectedEmpId;
  }

  // ------------------------------------------------ Get Departments  -------------------------------------
  departmentsList: any[] = [];
  getDepartments() {
    this.httpService.callGetService(`${this.config.getDwmDepartmentsByCompany}/${this.loggedInUserCompanyID}`).subscribe((res: any) => {
      this.departmentsList = res?.data || [];
      if (this.userIsAdminTypes?.userIsAdmin) {
        this.departmentsList = this.departmentsList.filter((department: any) => this.adminAccessData.department.includes(department));
      }
    });
  }

  // ------------------------------------------ On DepartmentChange Get  Grades --------------------------------------------------
  // selectedDepartment: string | null = null;
  // selectedGrade: string | null = null;
  // onDepartmentChange(department: string) {
  //   this.resetFilters('c1');
  //   if (!department) return;
  //   const payload = {
  //     companyId: this.loggedInUserCompanyID,
  //     department: [this.selectedDepartment]
  //   };
  //   this.httpService.callPostService(this.config.getDwmGradesByDepartment, payload).subscribe((res: any) => {
  //     this.gradesList = res?.data || [];
  //   });
  // }
  departmentDropdownSettings = {
    singleSelection: false,
    enableCheckAll: true,
    selectAllText: 'Select All',
    unSelectAllText: 'Unselect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };

  selectedDepartments: string[] = [];

  onDepartmentMultiChange() {
    this.resetFilters('c1');

    if (!this.selectedDepartments?.length) {
      this.gradesList = [];
      return;
    }

    const payload = {
      companyId: this.loggedInUserCompanyID,
      department: this.selectedDepartments
    };

    this.httpService.callPostService(this.config.getDwmGradesByDepartment, payload).subscribe((res: any) => {
      this.gradesList = res?.data || [];
    });
  }

  onDepartmentSelectAll() {
    // wait for ngModel to update selectedDepartments
    setTimeout(() => {
      this.onDepartmentMultiChange();
    });
  }

  onDepartmentDeSelectAll() {
    this.selectedDepartments = [];
    this.gradesList = [];
    this.employeesList = [];
  }

  get departmentCountLabel(): string {
    const count = this.selectedDepartments?.length || 0;
    return count > 1 ? `+${count - 1}` : '';
  }

  // ------------------------------------- On grade change get employees ----------------------------------
  employeesList: any[] = [];
  selectedGrades: string[] = [];
  gradeDropdownSettings = {
    singleSelection: false,
    enableCheckAll: true,
    selectAllText: 'Select All',
    unSelectAllText: 'Unselect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  // onGradeChange(grade: string) {
  //   this.resetFilters('c2');
  //   if (!this.selectedDepartment || !grade) return;
  //   const payload = {
  //     companyId: this.loggedInUserCompanyID,
  //     department: [this.selectedDepartment],
  //     grades: [this.selectedGrade]
  //   };
  //   this.httpService.callPostService(this.config.getDwmUserListByGrade, payload).subscribe((res: any) => {
  //     this.employeesList = res?.data || [];
  //     if (this.userIsAdminTypes?.userIsAdmin) {
  //       this.employeesList = this.employeesList.filter((emp: any) => this.adminAccessData.employeeDetails.some((empAdmin: any) => +emp.id === +empAdmin.employeeId));
  //     }
  //   });
  // }

  onGradeMultiChange() {
    this.resetFilters('c2');

    if (!this.selectedDepartments?.length || !this.selectedGrades?.length) {
      this.employeesList = [];
      return;
    }

    const payload = {
      companyId: this.loggedInUserCompanyID,
      department: this.selectedDepartments,
      grades: this.selectedGrades
    };

    this.httpService.callPostService(this.config.getDwmUserListByGrade, payload).subscribe((res: any) => {
      this.employeesList = res?.data || [];

      if (this.userIsAdminTypes?.userIsAdmin) {
        this.employeesList = this.employeesList.filter(emp => this.adminAccessData.employeeDetails.some((adminEmp: any) => +adminEmp.employeeId === +emp.id));
      }
    });
  }

  onGradeSelectAll() {
    setTimeout(() => {
      this.onGradeMultiChange();
    });
  }

  onGradeDeSelectAll() {
    this.selectedGrades = [];
    this.employeesList = [];
  }

  // --------------------------- get report data for Non R&D Users --------------------------------------

  getDwmYear(): number {
    if (!this.selectedMonthForDWM || !this.filteredMonthsList?.length) {
      return Number(this.selectedYearForDWM?.split('-')[0]);
    }
    const [startYear, endYear] = this.selectedYearForDWM?.split('-').map(Number);
    const fiscalStartMonth = this.filteredMonthsList[0];
    return this.monthsList.indexOf(this.selectedMonthForDWM) < this.monthsList.indexOf(fiscalStartMonth) ? endYear : startYear;
  }

  //  ------------------------------ Compliance Score -----------------------------------------
  getComplianceData: any = {};

  // complianceScore() {
  //   if (!this.selectedMonthForDWM) {
  //     this.getComplianceData = {};
  //     return;
  //   }

  //   let userId: number | null = null;
  //   let managerId: number | null = null;

  //   /* ================= EMPLOYEE ================= */
  //   if (this.loggedInUserRole === 'Employee') {
  //     userId = Number(this.loggedInUserId);
  //   } else if (this.loggedInUserRole === 'Manager' || this.loggedInUserRole === 'HOD') {
  //     /* ================= MANAGER / HOD ================= */

  //     if (this.isTeamView) {
  //       // Team View → managerId
  //       // managerId = Number(this.loggedInUserId);

  //       if (this.selectedFilters?.selectedEmpId) {
  //         userId = Number(this.selectedFilters.selectedEmpId);
  //       }
  //     } else {
  //       // Self View → only userId
  //       userId = Number(this.loggedInUserId);
  //     }
  //   } else {
  //     if (this.selectedFilters?.selectedEmpId) {
  //       userId = Number(this.selectedFilters.selectedEmpId);
  //     }
  //   }

  //   const payload = {
  //     companyId: this.loggedInUserCompanyID,
  //     year: this.getDwmYear(),
  //     month: this.monthsList.indexOf(this.selectedMonthForDWM) + 1,
  //     userId,
  //     managerId
  //   };

  //   // console.log('Compliance Payload →', payload);

  //   this.httpService.callPostService(this.config.getComplainceScore, payload).subscribe((res: any) => {
  //     // this.getComplianceData = res?.data || {};
  //     this.getComplianceData = { ...res?.data };
  //   });
  // }
  complianceScore() {
    if (!this.selectedMonthForDWM) {
      this.getComplianceData = {};
      return;
    }

    const userId = this.selectedFilters?.selectedEmpId ? Number(this.selectedFilters.selectedEmpId) : Number(this.loggedInUserId);

    const payload = {
      companyId: this.loggedInUserCompanyID,
      year: this.getDwmYear(),
      month: this.monthsList.indexOf(this.selectedMonthForDWM) + 1,
      userId: userId,
      managerId: null
    };

    this.httpService.callPostService(this.config.getComplainceScore, payload).subscribe((res: any) => {
      this.getComplianceData = res?.data || {};
    });
  }

  // ---------------------------------- Get weekly off and holiday-------------------------------------

  weeklyOffHolidayMap: {
    [day: number]: 'WEEKLY_OFF' | 'HOLIDAY';
  } = {};

  getWeeklyOff() {
    const year = this.getDwmYear();
    const month = this.getSelectedMonthNumber();
    const userId = this.getEffectiveUserId();
    this.weeklyOffHolidayMap = {};
    this.httpService.callGetService(`${this.config.getWeeklyOffHoliday}?userId=${userId}&companyId=${this.loggedInUserCompanyID}&year=${year}&month=${month}`).subscribe((res: any) => {
      const calendar = res?.data?.calendar || [];
      calendar.forEach((item: any) => {
        const dateObj = new Date(item.date);
        const day = dateObj.getDate();
        if (item.type === 'WEEKLY_OFF') {
          this.weeklyOffHolidayMap[day] = 'WEEKLY_OFF';
        }
        if (item.type === 'HOLIDAY') {
          this.weeklyOffHolidayMap[day] = 'HOLIDAY';
        }
      });
    });
  }

  isWeeklyOff(day: number): boolean {
    return this.weeklyOffHolidayMap[day] === 'WEEKLY_OFF';
  }

  isHoliday(day: number): boolean {
    return this.weeklyOffHolidayMap[day] === 'HOLIDAY';
  }

  nonRNDEmpReportData: any[] = [];

  getReportDataForNonRNDEmp() {
    const monthNumber = this.monthsList.indexOf(this.selectedMonthForDWM) + 1;

    const payload = {
      companyId: this.loggedInUserCompanyID,
      year: this.getDwmYear(),
      month: monthNumber,
      userId: this.getEffectiveUserId()
    };

    // this.httpService.callPostService(this.config.dwmReportForNonRnDUsers, payload).subscribe((res: any) => {
    //   this.nonRNDEmpReportData = res?.data || [];

    //   this.processNonRNDEmpReportData();
    //   this.prepareDays();
    // });
    this.httpService.callPostService(this.config.dwmReportForNonRnDUsers, payload).subscribe((res: any) => {
      const rawData = res?.data || [];

      const effectiveUserId = this.getEffectiveUserId();
      const loggedInManagerId = this.loggedInUserId;
      const isEmployee = this.loggedInUserRole === 'Employee';
      const isAdminUser = this.loggedInUserRole === 'Super Admin' || this.loggedInUserRole === 'HR Admin' || this.userIsAdminTypes?.userIsAdmin;
      this.nonRNDEmpReportData = rawData.filter((item: any) => {
        //  ADD ONLY FOR ADMIN ROLES
        if (isAdminUser && this.selectedFilters.selectedEmpId) {
          return Number(item.userId) === Number(effectiveUserId);
        }

        if (isEmployee) {
          //  Employee should see ONLY their own data
          return Number(item.userId) === Number(effectiveUserId);
        }
        if (!this.isTeamView) {
          return Number(item.userId) === Number(this.loggedInUserId);
        }
        return Number(item.userId) === Number(effectiveUserId);
      });
      this.processNonRNDEmpReportData();
      this.prepareDays();
    });
  }

  changeReportsData() {
    if (!this.selectedMonthForDWM) return;
    this.prepareDays();
    this.getWeeklyOff();
    this.getReportDataForNonRNDEmp();
    this.getReportDataForRNDEmp();
    this.complianceScore();
  }

  // ----------------------------------------------------------------------- Reports for Non R&D Users --------------------------------------------------

  daysInMonth: number[] = [];

  prepareDays() {
    if (!this.selectedMonthForDWM) {
      this.daysInMonth = [];
      return;
    }
    const year = this.getDwmYear();
    const month = this.monthsList.indexOf(this.selectedMonthForDWM); // 0-based

    const totalDays = new Date(year, month + 1, 0).getDate();
    this.daysInMonth = Array.from({ length: totalDays }, (_, i) => i + 1);
  }

  getSelectedMonthNumber(): number {
    return this.monthsList.indexOf(this.selectedMonthForDWM) + 1;
  }

  // -------------------------------- Pagination for Non-R&D Report ----------------------------------------
  hasSkippedEvent(events: any[]): boolean {
    return events?.some(ev => ev.isSkipped === true);
  }

  groupedReportData: any[] = [];

  isDaySkipped(task: any, day: number): boolean {
    const events = task?.events?.[day];
    if (!events || !events.length) return false;

    // If ANY entry for the day is skipped → show icon
    return events.some((ev: any) => ev.isSkipped === true);
  }

  processNonRNDEmpReportData() {
    const map = new Map<string, any>();
    this.nonRNDEmpReportData.forEach((item: any) => {
      const key = `${item.dwmMasterId}_${item.actionable}`;
      if (!map.has(key)) {
        map.set(key, {
          actionable: item.actionable,
          categoryName: item.categoryName,
          dwmFrequency: item.dwmFrequency,
          events: {} // day → array of { time, status }
        });
      }
      const group = map.get(key);
      const day = new Date(item.dwmEventDate).getDate();

      //  Initialize array per day
      if (!group.events[day]) {
        group.events[day] = [];
      }
      //  Push hourly entry instead of overwriting
      group.events[day].push({
        time: this.extractTime(item.actionableDescription),
        status: item.doneWithDelay ? 'Done_with_delay' : item.dwmStatus,
        isSkipped: item.isSkipped === true
      });
    });
    this.groupedReportData = Array.from(map.values());
    // Pagination
    this.totalTaskCount = this.groupedReportData.length;
    this.totalTaskPages = Math.ceil(this.totalTaskCount / this.selectedSizeOfTask);
    this.currentPageNumber = 1;
    this.applyTaskPagination();
  }

  extractTime(description: string): string {
    return description?.split(' ')?.pop() || '';
  }

  applyTaskPagination() {
    const startIndex = (this.currentPageNumber - 1) * this.selectedSizeOfTask;
    const endIndex = startIndex + this.selectedSizeOfTask;
    this.pagedGroupedReportData = this.groupedReportData.slice(startIndex, endIndex);
    this.showingCount = this.totalTaskCount === 0 ? 0 : startIndex + 1;
    this.showingOfCount = Math.min(endIndex, this.totalTaskCount);
  }

  onSelectSizeCount() {
    this.currentPageNumber = 1;
    this.totalTaskPages = Math.ceil(this.totalTaskCount / this.selectedSizeOfTask);
    this.applyTaskPagination();
  }

  previousPageTask() {
    if (this.currentPageNumber > 1) {
      this.currentPageNumber--;
      this.applyTaskPagination();
    }
  }

  nextPageTask() {
    if (this.currentPageNumber < this.totalTaskPages) {
      this.currentPageNumber++;
      this.applyTaskPagination();
    }
  }

  // resetFilters(filter: string) {
  //   if (filter == 'c1') {
  //     this.selectedFilters.selectedGrade = this.selectedFilters.selectedEmpId = null;
  //     this.gradesList = this.employeesList = [];
  //   } else if (filter == 'c2') {
  //     this.selectedFilters.selectedEmpId = null;
  //     this.employeesList = [];
  //   } else if (filter == 'c3') {
  //     this.selectedFilters = {
  //       selectedDepartment: null,
  //       selectedEmpId: null,
  //       selectedYear: null,
  //       selectedMonth: null
  //     };
  //     this.selectedDepartment = this.selectedGrade = null;
  //     this.departmentsList = this.gradesList = this.employeesList = this.groupedReportData = [];
  //   }
  // }
  resetFilters(filter: string) {
    if (filter === 'c1') {
      this.selectedGrades = [];
      this.selectedFilters.selectedEmpId = null;
      this.gradesList = [];
      this.employeesList = [];
    } else if (filter === 'c2') {
      this.selectedFilters.selectedEmpId = null;
      this.employeesList = [];
    }
  }

  // ---------------------------------------------------- download reports ----------------------------------------------
  downloadPDFAndExcel(downloadType: 'excel' | 'pdf') {
    const source = this.groupedReportData || [];
    if (!source.length) {
      this.toastr.warning('No task data available to export!');
      return;
    }
    const dayHeaders = this.daysInMonth.map(day => `Day ${day}`);

    /* ===================== EXCEL ===================== */
    if (downloadType === 'excel') {
      const excelData = source.map((task: any) => {
        const dayStatuses = this.daysInMonth.map(day => {
          if (this.isWeeklyOff(day)) {
            return 'WO';
          }

          if (this.isHoliday(day)) {
            return 'H';
          }
          const events = task.events?.[day];
          if (events?.some((ev: any) => ev.isSkipped === true)) {
            return 'Skipped Day';
          }

          if (!events || !events.length) {
            return 'N/A';
          }
          if (task.dwmFrequency === 'HOURLY') {
            return events.map((ev: any) => `${ev.time} - ${this.dwmGenericServiceService.getStatusLabel(ev.status)}`).join('\n');
          }
          return this.dwmGenericServiceService.getStatusLabel(events[0]?.status);
        });
        return {
          Category: task?.categoryName || '',
          Actionable: task?.actionable || 'N/A',
          Frequency: task?.dwmFrequency || '',
          ...dayHeaders.reduce((acc: { [key: string]: any }, dayHeader, index) => {
            acc[dayHeader] = dayStatuses[index];
            return acc;
          }, {})
        };
      });
      this.dwmGenericServiceService.saveAsExcelFile(excelData, 'My DWM Tasks', 'my_dwm_tasks');
    }

    /* ====================== PDF ====================== */
    if (downloadType === 'pdf') {
      const pdfTableHeaders: string[] = ['Category', 'Actionable', 'Frequency', ...this.daysInMonth.map(day => ` ${day}`)];
      const pdfTableData = source.map((task: any) => {
        const dayStatuses = this.daysInMonth.map(day => {
          if (this.isWeeklyOff(day)) {
            return 'WO';
          }

          if (this.isHoliday(day)) {
            return 'H';
          }
          const events = task.events?.[day];
          if (events?.some((ev: any) => ev.isSkipped === true)) {
            return 'Skipped Day';
          }
          if (!events || !events.length) {
            return 'N/A';
          }
          if (task.dwmFrequency === 'HOURLY') {
            return events.map((ev: any) => `${ev.time}\n${this.dwmGenericServiceService.getStatusLabel(ev.status)}`).join('\n\n');
          }
          return this.dwmGenericServiceService.getStatusLabel(events[0]?.status);
        });

        return [task.categoryName || '', task.actionable || '', task.dwmFrequency || '', ...dayStatuses];
      });

      const columnStyles: any = {
        0: { cellWidth: 28 },
        1: { cellWidth: 40 },
        2: { cellWidth: 18 }
      };
      this.daysInMonth.forEach((_, index) => {
        columnStyles[index + 3] = {
          cellWidth: 12,
          overflow: 'linebreak',
          halign: 'center',
          valign: 'top'
        };
      });
      this.dwmGenericServiceService.downloadTableAsPdfReport(pdfTableHeaders, pdfTableData, 'My DWM Tasks', 'my_dwm_tasks', {
        styles: {
          fontSize: 6,
          cellPadding: 1
        },
        headStyles: {
          fontSize: 7,
          overflow: 'linebreak'
        },
        columnStyles
      });
    }
  }
}
